
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  shallowRef,
  ref,
  toRef,
  watch,
} from "vue";
import { IBulkDelete } from "@/interfaces/iPageModel";
import { ITabConfig } from "@/interfaces/iTabConfig";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { TranslationService } from "@/core/services/TranslationService";
import { INNER_PAGE_ROWS_PER_PAGE, usePagination } from "@/helpers/pagination";
import { FormatMethods } from "@/helpers/data-format";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import {
  locationDeviceTableHeaders,
  deviceLocationTableBulkDelete,
  locationDeviceTableFilters,
} from "../dataTableOptions";
import { ISite } from "@/interfaces/iSite";
import { useToast } from "vue-toastification";
import { FORM_TABS } from "@/views/form/dataTableOptions";
import { hasPermission } from "@/core/services/permission.service";
import { LocationAPI } from "@/services/api/Location.service";
import { ISiteLocationDevice } from "@/interfaces/iLocation";
import DeviceDetailModal from "@/views/site/modal/DeviceDetailModal.vue";
import { SiteApi } from "@/services/api/Site.service";
import { Modal } from "bootstrap";
import { debounce } from "lodash";
export default defineComponent({
  props: {
    data: { type: Object as PropType<ISite>, required: true },
    openDrawer: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
  },
  components: { Datatable, VZDeleteModal, DeviceDetailModal },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const dataProp = toRef(props, "data");
    const openDrawer = toRef(props, "openDrawer");
    const { page, total } = usePagination();
    const rowsPerPage = ref(INNER_PAGE_ROWS_PER_PAGE);
    const loading = ref(false);
    const showSearch = true;
    const showDetailDialog = ref<any>(false);
    const tableData = ref<ISiteLocationDevice[]>([]);
    const selectedForAction = ref<Partial<ISiteLocationDevice>>({});
    const localPreference = ref({});
    const showDeleteDialog = ref<any>(false);
    const bulkDelete = ref<IBulkDelete>(deviceLocationTableBulkDelete());
    const tableHeader = ref(locationDeviceTableHeaders());
    const tableFilter = ref(locationDeviceTableFilters());
    const format = computed(() => {
      return FormatMethods;
    });
    const tabs = shallowRef<ITabConfig[]>(FORM_TABS());
    const viewName = "locationDevices";
    const toast = useToast();
    const message = t("common.deleteSuccessMessage");
    const deviceDetail = ref({});
    const Datatable = ref();
    let permissionModel = ref<any>({
      create: "VYZOR:BUSINESS:SITE:CREATE",
      delete: "VYZOR:BUSINESS:SITE:DELETE",
      update: "VYZOR:BUSINESS:SITE:UPDATE",
    });
    onMounted(async () => {
      try {
        // queryUpdate(dataProp.value.webId, {
        //   page: page.value - 1,
        //   size: rowsPerPage.value,
        // });
        loading.value = true;
      } catch (err) {
        console.log("error in getting location list: ", err);
      }
    });

    const syncQuery = async (params?: Record<string, number | string>) => {
      queryUpdate(dataProp.value.webId, params);
    };

    const queryUpdate = async (
      webId: number,
      params?: Record<string, number | string>
    ) => {
      try {
        loading.value = true;
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "createdDate,desc",
          };
        }
        const data = await LocationAPI.getInstance().getSiteDeviceList({
          ...params,
          locationId: dataProp.value.webId,
        });
        localPreference.value = { ...params };
        tableData.value = [...data.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } finally {
        loading.value = false;
      }
    };
    const onBulkDelete = async (ids) => {
      showDeleteDialog.value = false;
      let deletedMsg = "Selected device(s) " + message;
      await LocationAPI.getInstance()
        .deleteLocationDevice(ids)
        .then(() => {
          toast.success(deletedMsg);
          refreshList();
        })
        .catch(() => {
          //
        })
        .finally(() => {
          loading.value = false;
        });
    };
    const refreshList = () => {
      showDeleteDialog.value = false;
      queryUpdate(dataProp.value.webId, { ...localPreference.value });
    };

    const openDeviceDetail = async (device) => {
      try {
        showDetailDialog.value = true;
        deviceDetail.value = await SiteApi.getInstance().getDevice(+device);
        const modal = new Modal(
          document?.getElementById(`device_detail_modal`) as HTMLElement
        );
        modal?.show();
      } catch (e) {
        //
      }
    };

    const webId = computed(() => props.data?.webId);
    let lastFetchedWebId = null;

    const debouncedQueryUpdate = debounce(async (webId) => {
      if (webId !== lastFetchedWebId) {
        tableData.value = [];
        lastFetchedWebId = webId;
        await queryUpdate(+webId, {
          page: page.value - 1,
          size: INNER_PAGE_ROWS_PER_PAGE,
        });
      }
    }, 300);

    watch(
      () => props.isActive,
      async (isActive) => {
        if (isActive && dataProp.value.webId) {
          // await queryUpdate(dataProp.value.webId, {
          //   page: page.value - 1,
          //   size: rowsPerPage.value,
          // });
          loading.value = true;
          if (Datatable.value?.VZFilter) {
            await Datatable.value.VZFilter.getAppliedFilters();
          }
        } else {
          tableData.value = [];
        }
      }
    );
    return {
      Datatable,
      bulkDelete,
      format,
      tableData,
      tableHeader,
      showSearch,
      page,
      tabs,
      total,
      rowsPerPage,
      loading,
      selectedForAction,
      syncQuery,
      showDetailDialog,
      refreshList,
      viewName,
      onBulkDelete,
      openDeviceDetail,
      permissionModel,
      hasPermission,
      deviceDetail,
      showDeleteDialog,
      tableFilter,
      t,
    };
  },
});
